import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ChannelName } from '../../types';
import { T_KEYS } from '../../constants';
import {
  ManageHeader,
  ManageHeaderLeft,
  ManageHeaderInfo,
  ManageHeaderTitle,
  ManageHeaderDescription,
  ChannelLogoLarge,
  BackArrow,
} from '../../styles/ManageChannelStyles';

// Import unified channel logo components
import { ChannelLogo, ChannelLogoType } from '../ChannelLogos';

// Icons
const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M19 12H5M12 19l-7-7 7-7" />
  </svg>
);

interface IImportUnitsHeaderProps {
  channelName: ChannelName;
  channelDisplayName: string;
  onBack: () => void;
}

const ImportUnitsHeader: FC<IImportUnitsHeaderProps> = memo(({
  channelName,
  channelDisplayName,
  onBack,
}) => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';

  // Map channelName to ChannelLogoType
  const channelLogoType: ChannelLogoType = channelName as ChannelLogoType;

  return (
    <ManageHeader>
      <ManageHeaderLeft>
        <BackArrow onClick={onBack} aria-label={t(T_KEYS.BACK)}>
          <ArrowIcon />
        </BackArrow>
        <ChannelLogo channel={channelLogoType} size="lg" />
        <ManageHeaderInfo>
          <ManageHeaderTitle>
            {t(T_KEYS.IMPORT_UNITS_TITLE, { channel: channelDisplayName })}
          </ManageHeaderTitle>
          <ManageHeaderDescription>
            {t(T_KEYS.IMPORT_UNITS_DESCRIPTION, { channel: channelDisplayName })}
          </ManageHeaderDescription>
        </ManageHeaderInfo>
      </ManageHeaderLeft>
    </ManageHeader>
  );
});

ImportUnitsHeader.displayName = 'ImportUnitsHeader';

export default ImportUnitsHeader;
